import { meditacoes as fallback } from '../config/meditationsConfig';

const SHEET_URL =
  'https://docs.google.com/spreadsheets/d/12zPXBzCbjkg9Y_DdWIXiPAlKE5qKCeSC/export?format=csv&gid=76970285';

// Parser de CSV que lida com campos multi-linha (newlines dentro de aspas)
function parseCSVRows(text) {
  const rows = [];
  let current = '';
  let inQuotes = false;
  for (let i = 0; i < text.length; i++) {
    const ch = text[i];
    if (ch === '"') {
      inQuotes = !inQuotes;
      current += ch;
    } else if ((ch === '\n' || (ch === '\r' && text[i + 1] === '\n')) && !inQuotes) {
      if (ch === '\r') i++; // pula o \n do \r\n
      rows.push(current);
      current = '';
    } else {
      current += ch;
    }
  }
  if (current) rows.push(current);
  return rows;
}

function parseCSVLine(line) {
  const result = [];
  let current = '';
  let inQuotes = false;
  for (let i = 0; i < line.length; i++) {
    const ch = line[i];
    if (ch === '"') {
      inQuotes = !inQuotes;
    } else if (ch === ',' && !inQuotes) {
      result.push(current);
      current = '';
    } else {
      current += ch;
    }
  }
  result.push(current);
  return result;
}

function extrairYoutubeId(link) {
  if (!link) return null;
  // Suporta: youtube.com/watch?v=ID, youtu.be/ID, youtube.com/embed/ID
  const match = link.match(/(?:v=|youtu\.be\/|embed\/)([A-Za-z0-9_-]{11})/);
  return match ? match[1] : link.trim(); // se não casar, assume que já é o ID
}

export async function buscarMeditacoes() {
  try {
    const res = await fetch(`${SHEET_URL}&t=${Date.now()}`, { cache: 'no-store' });
    if (!res.ok) throw new Error(`HTTP ${res.status}`);
    const text = await res.text();
    const lines = parseCSVRows(text.trim());
    if (lines.length < 2) throw new Error('Planilha vazia');

    const headers = parseCSVLine(lines[0]).map(h => h.trim());

    return lines.slice(1)
      .map(line => {
        const cols = parseCSVLine(line);
        const obj = {};
        headers.forEach((h, i) => { obj[h] = (cols[i] || '').trim(); });
        return obj;
      })
      .filter(r => (r.ativo || '').toLowerCase() !== 'não')
      .map(r => ({
        id: r.id,
        titulo: r.titulo,
        descricao: r.descricao || undefined,
        duracao: r.duracao || undefined,
        categoria: r.categoria,
        youtubeId: extrairYoutubeId(r.youtubeLink),
      }))
      .filter(r => r.youtubeId && r.titulo && r.categoria);

  } catch (err) {
    console.warn('[meditationsContent] usando fallback estático:', err.message);
    return fallback;
  }
}
